import classNames from 'classnames';

const Index = ({
  variant = 'primary',
  type = 'button',
  disabled = false,
  className,
  onClick,
  children,
  ...rest
}) => {
  const base =
    'font-semibold px-4 py-1 border shadow focus:outline-none disabled:cursor-not-allowed';

  const variantClasses = {
    default: {
      active:
        'bg-white text-gray-900 border-gray-400 hover:bg-gray-100 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-900',
      disabled:
        'bg-gray-100 text-gray-500 border-gray-300 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600',
    },
    primary: {
      active:
        'bg-blue-600 text-white border-blue-700 hover:bg-blue-700 dark:bg-gray-800 dark:text-white dark:border-gray-800 dark:hover:bg-gray-900',
      disabled:
        'bg-blue-300 text-white border-blue-300 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600',
    },
    danger: {
      active:
        'bg-red-600 text-white border-red-700 hover:bg-red-700 dark:bg-gray-800 dark:text-white dark:border-gray-800 dark:hover:bg-gray-900',
      disabled:
        'bg-gray-300 text-white border-red-400 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-500',
    },
  };

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        base,
        className,
        variantClasses[variant][disabled ? 'disabled' : 'active']
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Index;
